import { Button } from "@heroui/react";
import { appRoutes } from "@sr-partner-portal/common";
import { useNavigate } from "react-router";

const LoginButton = ({
    primary,
    className,
}: {
    primary?: boolean;
    className?: string;
}) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(appRoutes(true).account().login().build());
    };

    return (
        <Button
            className={className}
            onPress={handleClick}
            variant={primary ? "solid" : "faded"}
            color={primary ? "primary" : "default"}
        >
            Login
        </Button>
    );
};

export { LoginButton };
